import 'whatwg-fetch';
import 'url-search-params-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { StepStudentPersonalInfoComponent } from './components/steps/StepStudentPersonalInfoComponent';
import { StepSuccessComponent } from './components/steps/StepSuccessComponent'
import { getCountryValidationError, graduationDateValidator } from './lib/Validators/validators';
import { StepDocUploadComponent } from './components/steps/StepDocUploadComponent';
import { StepSSOComponent } from './components/steps/StepSSOComponent'
import { defaultOptions } from './options';
import './index.css';
import App from './App';

import {
    setOptions,
    overrideComponent,
    setCustomValidator,
    setMetadata,
    StepComponent,
} from '@sheerid/jslib';
import { StepErrorComponent } from './components/steps/StepErrorComponent';
import { StepPendingComponent } from './components/steps/StepPendingComponent';



// Import default options from
setOptions(defaultOptions);

setMetadata({graduationDate: '', termsAndConditions: ''})
graduationDateValidator();

overrideComponent('StepStudentPersonalInfoComponent', StepStudentPersonalInfoComponent as unknown as StepComponent);
overrideComponent('StepDocUploadComponent', StepDocUploadComponent as unknown as StepComponent);
overrideComponent('StepPendingComponent', StepPendingComponent as unknown as StepComponent);
overrideComponent('StepSSOComponent', StepSSOComponent as unknown as StepComponent);
overrideComponent('StepSuccessComponent', StepSuccessComponent as unknown as StepComponent);
overrideComponent('StepErrorComponent', StepErrorComponent as unknown as StepComponent);
setCustomValidator("countryChoice", getCountryValidationError);

ReactDOM.render(<App />, document.getElementById('root'));
